/**
 * Pure resolution function for the active-party top-bar selector.
 *
 * Spec: active-party-top-bar — design.md "Resolution order".
 * Order: (1) persisted user preference -> (2) per-tenant default ->
 *        (3) the sole candidate when there is exactly one -> (4) null.
 * A persisted / default id is only honoured when it is a member of the
 * candidate set (stale ids are dropped). Deterministic — see property tests
 * P1 (determinism) and P2 (selection validity).
 */
export function resolveActivePartyId(
  persistedId: number | null | undefined,
  tenantDefaultId: number | null | undefined,
  candidates: ReadonlyArray<{ partyId: number }>
): number | null {
  const inCandidates = (id: number | null | undefined): id is number =>
    id != null && candidates.some((c) => c.partyId === id);

  if (inCandidates(persistedId)) return persistedId;
  if (inCandidates(tenantDefaultId)) return tenantDefaultId;
  if (candidates.length === 1) return candidates[0].partyId;
  return null;
}
